import { render, staticRenderFns } from "./SmileDesign.vue?vue&type=template&id=335c1960&scoped=true&"
import script from "./SmileDesign.vue?vue&type=script&lang=js&"
export * from "./SmileDesign.vue?vue&type=script&lang=js&"
import style0 from "./SmileDesign.vue?vue&type=style&index=0&id=335c1960&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335c1960",
  null
  
)

export default component.exports